import { OrderPlanningToolPanel } from "../OrderPlanningToolPanel";
import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningUnseatedTractor extends Layout {
    layoutOrderPlanningToolPanel: OrderPlanningToolPanel;
    sourceUnseatedTractor: DataSource;
    tableUnseatedTractor: Table;
}
